import React from 'react';
import { CapaQuotationChatMessageRfq } from '@generated/graphql';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import useStyles from '../useStyles';

interface Props {
  data?: CapaQuotationChatMessageRfq;
}

const ReviewCTA: React.FC<Props> = ({ data }) => {
  const classes = useStyles({ isOwner: true });
  const messageRfqData = data?.rfq;
  const projectName = messageRfqData?.projectName ?? '';
  const userManagerName = messageRfqData?.userManagerName ?? '';
  const userOrganizationName =
    messageRfqData?.userOrganizationName ?? undefined;
  const partnerManagerName = messageRfqData?.partnerManagerName ?? '';
  const partnerOrganizationName = messageRfqData?.partnerOrganizationName ?? '';

  return (
    <div className={classes['Chat-Message-Bubble-Common-root']}>
      <CustomizedTypography
        variant="body2"
        fontWeight="bold"
        color="primary"
        gutterBottoms={8}
      >
        거래완료
      </CustomizedTypography>
      <CustomizedTypography
        className="long-text"
        variant="body2"
        fontWeight="normal"
        gutterBottoms={16}
      >
        {userOrganizationName ? userOrganizationName + '의 ' : ''}
        {userManagerName}님과&nbsp;
        {partnerOrganizationName}의&nbsp;
        {partnerManagerName}&nbsp; 담당자님이 {projectName}
        &nbsp;프로젝트의 거래를 완료하셨습니다!
        <br />
        <br />
        다른 고객을 위해 솔직한 거래 후기를 남겨주세요!
      </CustomizedTypography>
      <CustomizedButton fullWidth color="primary" disabled>
        지금 바로 후기 작성하기
      </CustomizedButton>
    </div>
  );
};

export default ReviewCTA;
